// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__BU_ws","userSwitch":"header_userSwitch__SuHGy"};